import React, { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Alert, Card, Field, ProjectSelect, btn, input, iso, msg } from "./common";

function Item({ e, projects, onAct }) {
  const [pid, setPid] = useState("");
  const [due, setDue] = useState("");
  const go = (path, body) => onAct(api.post(`/workforce/equipment/${e.id}/${path}`, body));
  return (
    <Card testid={`wf-eq-${e.id}`} className="space-y-2">
      <div className="flex flex-wrap justify-between gap-2"><strong>{e.name}</strong><span data-testid={`wf-eq-status-${e.id}`}>{e.status.replace("_", " ")} · {e.location}</span></div>
      <p className="text-xs">{e.ownership}{e.serial ? ` · S/N ${e.serial}` : ""}{e.rental_return_on ? ` · return by ${e.rental_return_on}` : ""}{e.next_maintenance_on ? ` · maintenance due ${e.next_maintenance_on}` : ""}</p>
      <div className="flex flex-wrap gap-2 items-end">
        {e.status === "available" ? <>
          <Field id={`wf-eq-p-${e.id}`} label="Project"><ProjectSelect projects={projects} value={pid} onChange={setPid} testid={`wf-eq-project-${e.id}`} /></Field>
          <button type="button" className={btn} disabled={!pid} onClick={() => go("checkout", { project_id: pid })} data-testid={`wf-eq-out-${e.id}`}>Check out</button></>
          : <button type="button" className={btn} onClick={() => go("checkin", { location: "Yard" })} data-testid={`wf-eq-in-${e.id}`}>Check in to yard</button>}
        <Field id={`wf-eq-d-${e.id}`} label="Next maintenance due"><input id={`wf-eq-d-${e.id}`} type="date" className={input} value={due} onChange={(x) => setDue(x.target.value)} data-testid={`wf-eq-due-${e.id}`} /></Field>
        <button type="button" className={btn} onClick={() => go("maintenance", { performed_on: iso(new Date()), kind: "Service", next_due_on: due || null })} data-testid={`wf-eq-maint-${e.id}`}>Record service today</button>
      </div>
    </Card>
  );
}

function Inventory() {
  const [rows, setRows] = useState([]);
  const [d, setD] = useState({});
  const [err, setErr] = useState("");
  const load = useCallback(() => api.get("/workforce/inventory").then((r) => setRows(r.data)).catch((e) => setErr(msg(e))), []);
  useEffect(() => { load(); }, [load]);
  const adjust = (id, sign) => api.post(`/workforce/inventory/${id}/adjust`, { delta: sign * Number(d[id] || 0), reason: sign > 0 ? "Stock added" : "Used on site" })
    .then(() => { setErr(""); load(); }).catch((e) => setErr(msg(e)));
  return (
    <section className="space-y-2" data-testid="wf-inventory">
      <h2 className="font-heading text-lg">Material inventory</h2>
      <Alert text={err} testid="wf-inventory-error" />
      {rows.map((r) => (
        <Card key={r.id} testid={`wf-inv-${r.id}`} className="flex flex-wrap items-end gap-2">
          <span className="mr-auto">{r.location} · {r.item}: <strong data-testid={`wf-inv-qty-${r.id}`}>{r.quantity}</strong> {r.unit}</span>
          <Field id={`wf-inv-d-${r.id}`} label="Change by"><input id={`wf-inv-d-${r.id}`} type="number" min="0" className={input} value={d[r.id] || ""} onChange={(e) => setD({ ...d, [r.id]: e.target.value })} data-testid={`wf-inv-delta-${r.id}`} /></Field>
          <button type="button" className={btn} onClick={() => adjust(r.id, 1)} data-testid={`wf-inv-add-${r.id}`}>Add</button>
          <button type="button" className={btn} onClick={() => adjust(r.id, -1)} data-testid={`wf-inv-use-${r.id}`}>Use</button>
        </Card>))}
    </section>
  );
}

export default function Equipment({ projects }) {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState("");
  const load = useCallback(() => api.get("/workforce/equipment").then((r) => setRows(r.data)).catch((e) => setErr(msg(e))), []);
  useEffect(() => { load(); }, [load]);
  const onAct = (p) => p.then(() => { setErr(""); load(); }).catch((e) => setErr(msg(e)));
  return (
    <div className="space-y-6">
      <section className="space-y-2" data-testid="wf-equipment">
        <h2 className="font-heading text-lg">Equipment register</h2>
        <Alert text={err} testid="wf-equipment-error" />
        {rows.map((e) => <Item key={e.id} e={e} projects={projects} onAct={onAct} />)}
      </section>
      <Inventory />
    </div>
  );
}
